import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {GatewayModel} from '../../../../types/gateway';
import {useMessage} from '../../../../hooks/message';
import {useQuestion} from '../../../../hooks/question';
import {useRPC} from '../../../../hooks/rpc';
import {GatewayCommand} from '../../../../types/control';
import {useLocalization} from "../../../../hooks/localization";

export const GATEWAY_TYPES = {
    '1': 'NOVA_PANEL',
    '2': 'HOME_MANAGER',
};

const keyExtractor = (item: GatewayModel) => item.id;

export const GatewayListScreen = memo(function GatewayListScreen() {
    const {t} = useLocalization();
    const {success} = useMessage();
    const question = useQuestion();
    const [rpc] = useRPC();

    const gatewayList = useSelector(state => state.control.gatewayList);

    const [selectedGateway, setSelectedGateway] = useState<GatewayModel>(null);

    const onRestartClick = useCallback(() => {
        question(t('this_will_be_rebooted__continue',{name:selectedGateway.name}), () => {
            success(t('rebooting'));
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Reboot);
        });
    }, [
        t,
        rpc,
        question,
        selectedGateway,
        success,
    ]);

    const buttons = useMemo(() => [
        {
            text: t('manage'),
            url: `/settings/gateway-control/${selectedGateway ? selectedGateway.id : ''}`,
            className: 'red',
            hidden: !(selectedGateway),
        },
        {
            text: t('deployment'),
            url: `/settings/gateway/${selectedGateway ? selectedGateway.id : ''}/setup/match`,
            className: 'blue',
            hidden: !(selectedGateway),
        },
        {
            text: t('edit'),
            url: `/settings/gateway/edit/${selectedGateway ? selectedGateway.id : ''}`,
            className: 'orange',
            hidden: !(selectedGateway),
        },
        /*{
            text: 'GATEWAY OLUŞTUR',
            url: '/settings/gateway/edit',
            className: 'green',
        },*/
    ], [t, selectedGateway]);


    const displayNameExtractor = useCallback((item: GatewayModel, column: ColumnModel) => {
        if (column.key === 'type') {
            return t(GATEWAY_TYPES[item.type_id]);
        } else if (column.key === 'ip_address') {
            return item.settings.home_network.ip_address || '-';
        }

        return item[column.key] || '-';
    }, [t]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('gateway_name'),
            key: 'name',
        },
        {
            length: 2,
            name: t('type'),
            key: 'type',
        },
        {
            length: 2,
            name: t('ip_address'),
            key: 'ip_address',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className='device-list-page' backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={gatewayList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedGateway}
                    onItemSelected={setSelectedGateway}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
